<template>
  <v-text-field
    :disabled="disabled"
    v-model="inputValue"
    :label="!labelAbove && !hideLabel ? label : ''"
    :error-messages="errorMessage"
    :filled="filled"
    :dense="dense"
    :outlined="outlined"
    :hide-details="hideDetails"
    v-bind="$attrs"
    @keydown="keyDown"
    @keyup="keyUp"
    @focus="onFocus"
    @blur="onBlur"
    @keypress="onKeypress"
    @click="$emit('click', $event)"></v-text-field>
</template>

<script>
export default {
  name: 'InputTel',
  props: {
    value: { type: [String, Number], default: null },
    label: { type: String, default: 'Enter text' },
    hint: { type: String, default: null },
    error: { type: Boolean, default: Boolean },
    errorMessage: { type: [String, Array], default: null },
    disabled: { type: Boolean, default: false },
    type: { type: String, default: 'tel' },
    readonly: { type: Boolean, default: false },
    valid: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    noCountrySelector: { type: Boolean, default: false },
    filled: { type: Boolean, default: true },
    dense: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    labelAbove: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
    hideLabel: { type: Boolean, default: false },
  },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    onFocus: function () {
      this.$emit('focus')
    },
    onBlur: function () {
      this.$emit('blur')
    },
    clear () {
      this.$emit('input', null)
      this.$emit('clear')
    },
    keyUp (e) {
      this.$emit('keyup', e)
    },
    keyDown (e) {
      this.$emit('keydown', e)
    },
    onKeypress (e) {
      if (/[^+ 0-9]/.test(e.key)) {
        e.preventDefault()
      }

      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.v-text-field--filled {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.v-text-field::v-deep {
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
}
</style>